<template>
    <div class="w-full min-h-screen flex flex-col bg-white">
        <header class="font-worksans flex-shrink-0 lg:px-20 lg:pt-7 z-50">
            <div class="flex justify-between items-center">
                <div
                    class="w-full flex flex-col lg:divide-y items-start lg:space-y-5"
                >
                    <div
                        :class="isOpen ? 'justify-end' : 'justify-between '"
                        class="flex w-full px-10 lg:px-0 lg:space-x-3"
                    >
                        <div
                            v-if="!isOpen"
                            class="lg:flex flex-grow lg:py-0 items-center space-y-7 lg:space-y-0"
                        >
                            <a class="flex justify-center text-center" href="/">
                                <img
                                    :class="[
                                        $page.component != 'LocalJobs'
                                            ? 'hidden'
                                            : 'h-36',
                                    ]"
                                    src="@/../assets/images/CDL_Local_Logo.jpg"
                                    alt="Open CDL Jobs"
                                />
                                <img
                                    :class="[
                                        $page.component === 'LocalJobs'
                                            ? 'hidden'
                                            : 'h-16',
                                    ]"
                                    src="@/../assets/images/opencdljobs.png"
                                    alt="Open CDL Jobs"
                                />
                            </a>
                            <template class="hidden md:flex w-full justify-end">
                                <nav class="flex items-center space-x-12">
                                    <Link
                                        :href="route('home')"
                                        :class="{
                                            'border-b-4 border-blue-500 pb-3 text-blue-500':
                                                $page.component === 'Home',
                                        }"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Home</Link
                                    >

                                    <Link
                                        :href="route('blog')"
                                        :class="{
                                            'border-b-4 border-blue-500 pb-3 text-blue-500':
                                                $page.component ===
                                                    'Blog/Index' ||
                                                $page.component === 'Blog/Show',
                                        }"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Blog</Link
                                    >

                                    <!-- <Link
                                        v-if="!auth"
                                        :href="route('agent.login.show')"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Agent Login
                                    </Link>
                                    <Link
                                        v-if="!auth"
                                        :href="route('login.show')"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Job Seekers
                                    </Link>
                                    <Link
                                        v-if="!auth"
                                        :href="route('recruiters.login.show')"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Employers
                                    </Link> -->
                                    <!-- <Link
                    :href="route('cdl-local-jobs')"
                    :class="{
                      'border-none bg-blue-500 pb-3 text-white':
                        $page.component === 'LocalJobs',
                    }"
                    class="
                      text-md
                      text-blue-500
                      tracking-wider
                      font-bold border-2 border-blue-500 px-2 py-2 rounded
                      hover:bg-blue-600 hover:text-white
                      transition
                    "
                    >CDL Local Jobs</Link
                  > -->

                                    <!-- <a
                                        href="/"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Drivers</a
                                    >
                                    <a
                                        href="/"
                                        class="text-md tracking-wider font-bold hover:text-gray-300 transition"
                                        >Employers</a
                                    > -->
                                </nav>
                            </template>
                        </div>
                        <div class="sm:hidden">
                            <button
                                @click="isOpen = !isOpen"
                                class="block pt-6"
                                aria-label="menu"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-9 w-9"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        v-if="!isOpen"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                    <path
                                        v-if="isOpen"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Mobile view -->
                    <div
                        v-if="isOpen"
                        class="lg:hidden relative md:flex w-full md:justify-between pt-3"
                    >
                        <nav
                            class="absolute h-screen w-full z-10 bg-white pb-48 flex flex-col text-justify justify-center items-center md:flex-none md:flex-row space-y-7 md:space-x-8 md:space-y-0"
                        >
                            <Link
                                :href="route('home')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >Home</Link
                            >
                            <Link
                                :href="route('blog')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >Blog</Link
                            >
                            <Link
                                :href="route('about')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >About</Link
                            >
                            <Link
                                :href="route('contact')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >Contact</Link
                            >
                            <Link
                                :href="route('privacy-policy')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >Privacy Policy</Link
                            >
                            <!-- <Link
                                v-if="!auth"
                                :href="route('agent.login.show')"
                                class="text-[20px] font-extralight transition"
                                @click="isOpen = !isOpen"
                                >Login as Agent
                            </Link> -->
                            <!-- <Link
                    :href="route('cdl-local-jobs')"
                    class="
                      text-md
                      text-blue-500
                      tracking-wider
                      font-bold border-2 border-blue-500 px-2 py-2 rounded
                      hover:bg-blue-600 hover:text-white
                      transition
                    "
                    @click="isOpen = !isOpen"
                    >CDL Local Jobs</Link
                  > -->
                            <!-- <a
                    href="/"
                    class="text-[20px] font-extralight transition"
                    >Blog</a
                  >
                  <a
                    href="/"
                    class="text-[20px] font-extralight transition"
                    >Drivers</a
                  >
                  <a
                    href="/"
                    class="text-[20px] font-extralight transition"
                    >Employers</a
                  >         -->
                        </nav>
                    </div>
                </div>

                <!-- Disabled for initial launch -->
                <div class="flex">
                    <ProfileDropdown v-if="auth" :auth="auth" />
                    <!-- <template v-else>
            <Link
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              :href="route('register.create')"
              >Register</Link
            >
            <Link
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              :href="route('login.show')"
              >Login</Link
            >
          </template> -->
                </div>
            </div>
        </header>

        <main class="flex-1">
            <slot></slot>
        </main>

        <AppFooter class="pt-6" :auth="auth" />

        <FlashMessage />
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import ProfileDropdown from "@/components/ProfileDropdown";
import FlashMessage from "@/components/FlashMessage";
import AppFooter from "@/components/Layouts/Footer";

import { computed, ref, watch, watchEffect } from "vue";

export default {
    props: {
        auth: Object,
    },

    setup(props) {
        let isOpen = ref(false);
        const year = computed(() => new Date().getFullYear());

        return {
            year,
            isOpen,
            route: window.route,
        };
    },

    components: {
        Link,
        AppFooter,
        FlashMessage,
        ProfileDropdown,
    },
};
</script>
